import { InjectionToken } from '@angular/core';

export const HUBSPOT_FUNCTIONS_BASE_URL = new InjectionToken<string>(
  'HUBSPOT_FUNCTIONS_BASE_URL',
);
